import React from "react";
import "../styles/Logo.scss";
import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from "react-router-dom";

export const Logo: React.FC<{ titleColor?: string }> = (props) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  // Get the current language from the URL path
  const currentLanguage =
    location.pathname.split("/")[1] || i18n.language || "en";

  // Navigate to the home page in the current language
  const handleLogoClick = () => {
    navigate(`/${currentLanguage}`);
  };

  return (
    <div
      onClick={handleLogoClick}
      className="logo"
      style={{ direction: "ltr", cursor: "pointer" }}
    >
      <img className="logo-img" src="/images/logo.svg" alt="Logo" />
      <p style={{ color: props.titleColor }}>{t("weCare")}</p>
    </div>
  );
};
